import {Button, Datagrid, DateField, FunctionField, TextField} from "react-admin";
import {DatagridPropsWithOptions} from "../../shared/types";
import {initField} from "../../shared/utils";
import {ReconciliationSelectField} from "./ReconciliationSelectField";
import {Typography} from "@material-ui/core";

export const FileRowDatagrid = ({
  selectedRow, 
  setSelectJournalEntry, 
  setSelectFileRow, 
  options, 
  ...rest
}: DatagridPropsWithOptions & {
  selectedRow: any[];
  setSelectJournalEntry: React.Dispatch<React.SetStateAction<any[]>>;
  setSelectFileRow: React.Dispatch<React.SetStateAction<any[]>>;
}) => {
  return options ? (
    <Datagrid {...rest} style={{"overflow":"auto"}}>
      <ReconciliationSelectField 
        selectedRow={selectedRow} 
        setSelectedRow={setSelectFileRow}
      />
      <FunctionField
        label="Importo"
        render={(tableRecord: any | undefined) => {
          if (tableRecord.row_type === "I") {
            return <Typography style={{ color: "green" }}>+ {tableRecord.value}</Typography>
          } else {
            return <Typography color="primary">- {tableRecord.value}</Typography>
          }
        }}
      />
      <FunctionField
        label="Consigliato"
        source="advised"
        render={(tableRecord: any | undefined) => {
          if (!tableRecord || !tableRecord.advised || tableRecord.advised.length <= 0)
            return null;
          return <Button 
            label="Consigliato" 
            onClick={() => {setSelectJournalEntry(tableRecord.advised); setSelectFileRow([tableRecord.id])}}
          />;
        }}
      />
      <TextField {...initField("description", options)} style={{whiteSpace: "pre-wrap"}}/>
      <DateField {...initField("value_date", options)} />
    </Datagrid>
  ) : null;
};